import { createSelector } from 'reselect'

const interactiveVideoSettingsSelector = state => state.interactiveVideoCreation.settings
const qsSelector = state => state.qs

export default createSelector(
	[ interactiveVideoSettingsSelector, qsSelector ],
	(interactiveVideoSettingsData, qs) => ({
		title: interactiveVideoSettingsData.videoTitle,
		canNavigateToPicker: !!qs.picker,
	})
)
